import { z } from "zod/v4-mini";

import { type FileModel, fileSchema } from "@/models/FileModel.ts";
import { type RenewType, renewTypeSchema } from "@/models/PatientRenewalInfoModel.ts";
import {
  type ReinclusionAgentSuggestion,
  reinclusionAgentSuggestionSchema,
} from "@/models/ReinclusionAgentSuggestionModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export type ReinclusionStateForNurse = {
  canReinclude: boolean;
  lastCarePlanEnd?: string;
  reinclusionRequestActive: boolean;
  suggestion?: ReinclusionAgentSuggestion;
};

export type ReinclusionStateForDoctor = {
  lastCarePlanEnd?: string;
  reinclusionRequestActive: boolean;
  nurseFirstName?: string;
  nurseLastName?: string;
  nurseProfilePicture?: FileModel;
  renewalType?: RenewType;
  nurseMessage?: string;
};

export const reinclusionStateForNurseSchema: Schema<ReinclusionStateForNurse> = cz.camelCaseObject({
  can_reinclude: z.boolean(),
  last_care_plan_end: cz.optional(z.string()),
  reinclusion_request_active: z.boolean(),
  suggestion: cz.optional(reinclusionAgentSuggestionSchema),
});

export const reinclusionStateForDoctorSchema: Schema<ReinclusionStateForDoctor> = cz.camelCaseObject({
  last_care_plan_end: cz.optional(z.iso.date()),
  reinclusion_request_active: z.boolean(),
  nurse_first_name: cz.optional(z.string()),
  nurse_last_name: cz.optional(z.string()),
  nurse_profile_picture: cz.optional(fileSchema),
  renewal_type: cz.optional(renewTypeSchema),
  nurse_message: cz.optional(z.string()),
});
